import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL;

interface Blog {
  id: number;
  title: string;
  description: string;
  imageUrl?: string | null;
}

const BlogsSection: React.FC = () => {
  const [blogs, setBlogs] = useState<Blog[]>([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch(`${API_URL}/api/blogs`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        if (!res.ok) throw new Error('Failed to fetch blogs');
        const data: Blog[] = await res.json();
        setBlogs(data);
      } catch (err) {
        console.error('Error fetching blogs:', err);
      }
    };
    fetchBlogs();
  }, []);

  return (
    <section className="blogs-section py-5">
      <Container>
        <h2 className="blogs-title text-center mb-5 mt-5">Our Blogs</h2>
        <Row>
          {blogs.length > 0 ? (
            blogs.map((blog) => (
              <Col md={4} key={blog.id} className="mb-4">
                <Card className="blog-card">
                  <Card.Img
                    variant="top"
                    src={blog.imageUrl ? `${API_URL}${blog.imageUrl}` : 'https://via.placeholder.com/300x200.png?text=Blog+Image'}
                    className="blog-image"
                  />
                  <Card.Body>
                    <Card.Title className="blog-card-title">{blog.title}</Card.Title>
                    <Card.Text className="blog-card-text">{blog.description}</Card.Text>
                    <Button variant="primary" className="blog-read-more-btn">
                      Read More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))
          ) : (
            <Col>
              <p className="text-center">No blogs available.</p>
            </Col>
          )}
        </Row>
      </Container>
    </section>
  );
};

export default BlogsSection;